"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PERISCOPE_PICKLIST_COPY = void 0;
exports.PERISCOPE_PICKLIST_COPY = {
    DESCRIPTION_MIDDLE: ' field, on the ',
    DESCRIPTION_PREFIX: 'A Picklist Value of the ',
    DESCRIPTION_SUFFIX: ' object.'
};
//# sourceMappingURL=COPY.js.map